module.exports = __webpack_public_path__ + "img/fleet-type.ca495f2b.svg";